module.exports = __webpack_public_path__ + "img/tree_1_3.f4fb84e1.png";